import { __assign } from "tslib";
import { ReplaySubject } from 'rxjs';
import create from 'zustand';
export var useEdgeworthDataStore = create(function (set, get) { return ({
    allFiles: [],
    allFilesMap: new Map(),
    changedFilesSubject: new ReplaySubject(),
    updateAllFiles: function () {
        set({
            allFiles: Array.from(get().allFilesMap.values()),
        });
    },
    updateFile: function (id, updaterCallback) {
        var documentsMap = get().allFilesMap;
        if (!documentsMap.has(id)) {
            return;
        }
        var newDocument = __assign({}, documentsMap.get(id));
        updaterCallback(newDocument);
        documentsMap.set(id, newDocument);
        set({
            allFiles: Array.from(documentsMap.values()),
        });
    },
}); });
export var useEdgeworthDataStoreUpdaterUnreactive = function () {
    return useEdgeworthDataStore.getState().updateFile;
};
//# sourceMappingURL=useEdgeworthDataStore.js.map